import React from 'react';
import classNames from 'classnames';

import css from './Icon.module.scss';

export type IconType =
  | 'share'
  | 'whatsApp'
  | 'facebook'
  | 'x'
  | 'n-12-logo'
  | 'help'
  | 'vs'
  | 'close'
  | 'border'
  | 'results-star'
  | 'no-results';

interface Props {
  type: IconType;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
}

const Icon = ({ type, className, width, height, color = '', secondaryColor, ...iconProps }: Props) => {
  let icon = null;
  const svgProps = {
    width,
    height,
    viewBox: `0 0 ${width || 38} ${height || 38}`,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'share':
      icon = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.3179 19.7252L9.24533 15.6418L10.237 13.9242L17.3095 18.0076L16.3179 19.7252Z" fill="#1E3761" />
          <path
            d="M8.16668 17.0916C6.4592 17.0916 5.07501 15.7074 5.07501 13.9999C5.07501 12.2925 6.4592 10.9083 8.16668 10.9083C9.87416 10.9083 11.2583 12.2925 11.2583 13.9999C11.2583 15.7074 9.87416 17.0916 8.16668 17.0916ZM8.10835 15.4583C8.94598 15.4583 9.62501 14.7792 9.62501 13.9416C9.62501 13.104 8.94598 12.4249 8.10835 12.4249C7.27071 12.4249 6.59168 13.104 6.59168 13.9416C6.59168 14.7792 7.27071 15.4583 8.10835 15.4583Z"
            fill="#1E3761"
          />
          <path
            d="M18.6667 22.925C16.9592 22.925 15.575 21.5408 15.575 19.8333C15.575 18.1258 16.9592 16.7416 18.6667 16.7416C20.3742 16.7416 21.7583 18.1258 21.7583 19.8333C21.7583 21.5408 20.3742 22.925 18.6667 22.925ZM18.6083 21.2916C19.446 21.2916 20.125 20.6126 20.125 19.775C20.125 18.9373 19.446 18.2583 18.6083 18.2583C17.7707 18.2583 17.0917 18.9373 17.0917 19.775C17.0917 20.6126 17.7707 21.2916 18.6083 21.2916Z"
            fill="#1E3761"
          />
          <path d="M16.3179 8.74137L9.24533 12.8247L10.237 14.5423L17.3095 10.459L16.3179 8.74137Z" fill="#1E3761" />
          <path
            d="M18.6667 5.07497C16.9592 5.07497 15.575 6.45915 15.575 8.16663C15.575 9.87411 16.9592 11.2583 18.6667 11.2583C20.3742 11.2583 21.7583 9.87411 21.7583 8.16663C21.7583 6.45915 20.3742 5.07497 18.6667 5.07497ZM18.6083 6.7083C19.446 6.7083 20.125 7.38734 20.125 8.22497C20.125 9.0626 19.446 9.74163 18.6083 9.74163C17.7707 9.74163 17.0917 9.0626 17.0917 8.22497C17.0917 7.38734 17.7707 6.7083 18.6083 6.7083Z"
            fill="#1E3761"
          />
        </svg>
      );
      break;

    case 'whatsApp':
      icon = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.8594 2.2112L16.1092 2.10635C13.8545 1.78215 11.5537 2.10288 9.47514 3.03113C7.39652 3.95939 5.62569 5.45693 4.36908 7.34916C3.03207 9.15791 2.23505 11.3058 2.06973 13.5458C1.90441 15.7857 2.37752 18.0266 3.43461 20.0106C3.54279 20.2094 3.61014 20.4277 3.63274 20.6527C3.65534 20.8778 3.63273 21.105 3.56622 21.3213C3.0266 23.1694 2.52646 25.0306 2 26.9835L2.65808 26.7869C4.43488 26.3151 6.21169 25.8432 7.98849 25.4107C8.36352 25.333 8.75333 25.3696 9.10722 25.5155C10.7013 26.2903 12.4434 26.7166 14.2166 26.7657C15.9897 26.8148 17.7529 26.4856 19.3878 25.8003C21.0227 25.1149 22.4915 24.0892 23.6956 22.792C24.8997 21.4949 25.8112 19.9562 26.369 18.2793C26.9268 16.6024 27.118 14.8261 26.9297 13.0696C26.7415 11.3131 26.1781 9.617 25.2774 8.09516C24.3767 6.57332 23.1596 5.26094 21.7077 4.2461C20.2558 3.23126 18.6027 2.53744 16.8594 2.2112ZM20.1761 19.4076C19.6977 19.8341 19.1144 20.1268 18.4856 20.2557C17.8567 20.3846 17.2048 20.3453 16.5961 20.1416C13.8387 19.3672 11.4464 17.6442 9.84427 15.2789C9.23249 14.4422 8.74078 13.5246 8.38334 12.5527C8.18967 11.9888 8.15475 11.3828 8.28236 10.8006C8.40997 10.2183 8.69524 9.68195 9.10722 9.24969C9.30779 8.99477 9.58079 8.80592 9.89067 8.70773C10.2006 8.60954 10.5329 8.60657 10.8445 8.69919C11.1078 8.76473 11.292 9.14483 11.5289 9.43318C11.722 9.97494 11.9457 10.5036 12.2002 11.0191C12.3929 11.2819 12.4734 11.61 12.4241 11.9317C12.3748 12.2534 12.1996 12.5426 11.937 12.7362C11.3447 13.2604 11.4368 13.693 11.858 14.2828C12.7886 15.6191 14.0735 16.6718 15.5695 17.3236C15.9907 17.5071 16.3066 17.5464 16.583 17.1139C16.7014 16.9435 16.8594 16.7993 16.991 16.6421C17.7543 15.6852 17.5174 15.6984 18.7283 16.2226C19.1144 16.3843 19.4873 16.5722 19.847 16.7862C20.2024 16.996 20.742 17.2188 20.821 17.5333C20.897 17.8746 20.877 18.2301 20.7632 18.5608C20.6494 18.8915 20.4463 19.1845 20.1761 19.4076Z"
            fill="#1E3761"
          />
        </svg>
      );
      break;
    case 'facebook':
      icon = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M27 14.5508C26.9854 17.6363 25.8423 20.6087 23.7884 22.9015C21.7345 25.1943 18.9133 26.6472 15.8625 26.9835V17.969H18.8C18.9293 17.9698 19.0543 17.9228 19.1515 17.8372C19.2487 17.7515 19.3113 17.633 19.3275 17.5041L19.645 14.7368C19.6565 14.6641 19.652 14.5898 19.632 14.519C19.6119 14.4483 19.5767 14.3828 19.5289 14.3271C19.481 14.2715 19.4216 14.227 19.3549 14.1968C19.2882 14.1666 19.2157 14.1515 19.1425 14.1524H15.8625V11.8903C15.8625 10.8397 16.1537 10.1221 17.6475 10.1221H19.0375C19.1756 10.1185 19.3067 10.0607 19.403 9.96111C19.4992 9.86153 19.5529 9.72805 19.5525 9.58921V7.20898C19.5492 7.07018 19.4921 6.93817 19.3933 6.84118C19.2945 6.74419 19.1618 6.68991 19.0238 6.68995H16.775C16.1433 6.64454 15.5094 6.73826 14.9175 6.96456C14.3256 7.19087 13.7899 7.5443 13.3479 8.00021C12.9058 8.45612 12.5681 9.00351 12.3582 9.60419C12.1482 10.2049 12.0712 10.8444 12.1325 11.4781V14.1373H9.92375C9.85478 14.1373 9.78651 14.1511 9.72296 14.1781C9.65941 14.205 9.60188 14.2445 9.55376 14.2942C9.50564 14.3438 9.4679 14.4027 9.44278 14.4673C9.41766 14.5318 9.40566 14.6008 9.4075 14.6701V17.4349C9.4075 17.5726 9.46189 17.7046 9.55871 17.8019C9.65552 17.8993 9.78683 17.954 9.92375 17.954H12.1325V26.7975C9.29621 26.2476 6.73691 24.727 4.8897 22.4944C3.04249 20.2617 2.02139 17.4548 2 14.5508C2 11.2177 3.31696 8.02119 5.66117 5.66438C8.00537 3.30756 11.1848 1.98352 14.5 1.98352C17.8152 1.98352 20.9946 3.30756 23.3388 5.66438C25.683 8.02119 27 11.2177 27 14.5508Z"
            fill="#1E3761"
          />
        </svg>
      );
      break;
    case 'x':
      icon = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14.5" cy="14.4835" r="12.5" fill="#1E3761" />
          <path
            d="M18.5257 8.48352H20.6726L15.9826 13.5669L21.5 20.4835H17.1796L13.7965 16.2882L9.9248 20.4835H7.7758L12.7927 15.0469L7.5 8.48352H11.9296L14.9886 12.3182L18.5257 8.48352ZM17.7725 19.2649H18.9625L11.2828 9.63819H10.006L17.7725 19.2649Z"
            fill="#E9EBF0"
          />
        </svg>
      );
      break;

    case 'n-12-logo':
      icon = (
        <svg width="40" height="28" viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6135 23.0008H11.5528C10.7525 23.0011 10.0183 22.5539 9.64803 21.8404L3.3844 9.81209V23.0008H0V5.10403H3.44513C4.24514 5.10352 4.97914 5.55013 5.3499 6.26301L11.6135 18.2913V5.10403H14.9965V23.0008H11.6135ZM22.8969 5.17344H20.0563L19.1164 7.05278H22.4994V21.3505H21.2903V8.27282H18.5063L17.6782 9.93147H19.5194V23.0244H24.2689V6.542C24.2674 6.17756 24.1221 5.82863 23.8648 5.57198C23.6075 5.31532 23.2593 5.17196 22.8969 5.17344ZM39.2296 21.3643H28.5754L34.2207 12.9448C34.2248 12.9392 34.2276 12.9364 34.2303 12.9323C34.5295 12.5334 34.7377 12.0733 34.8404 11.5845L34.8445 11.5623C34.8761 11.3897 34.8918 11.2146 34.8915 11.0391C34.8946 10.2337 34.5711 9.46179 33.9957 8.90156C32.7895 7.73566 30.883 7.73566 29.6768 8.90156C29.1014 9.46179 28.7779 10.2337 28.781 11.0391H30.6209C30.6183 10.5235 30.9409 10.0629 31.4246 9.89178C31.9082 9.72066 32.4466 9.87664 32.7656 10.2803C33.0846 10.684 33.114 11.2466 32.839 11.6817C32.8335 11.6914 25.2572 23.0243 25.2572 23.0243H39.9998L39.2296 21.3643ZM25.7555 11.0391H27.6203C27.6167 9.91827 28.0619 8.84321 28.8556 8.05629C30.5068 6.41305 33.1658 6.41305 34.8169 8.05629C36.2267 9.45679 36.4572 11.6633 35.3677 13.3279L30.8459 20.1623H38.672L37.859 18.4107H34.153C34.153 18.4107 36.1365 15.5528 36.8294 14.398C37.5223 13.2432 37.8301 12.1897 37.8549 11.0307C37.859 10.6292 37.8192 10.2285 37.7362 9.83569C37.1113 6.78141 34.2919 4.69614 31.2064 5.00606C28.1208 5.31598 25.7673 7.92084 25.7555 11.0391Z"
            fill="#1E3761"
          />
        </svg>
      );
      break;

    case 'help':
      icon = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5074 17.6406C13.8243 17.6406 14.1017 17.7689 14.3329 18.0071L14.4185 18.0995C14.6066 18.3214 14.7042 18.5815 14.7043 18.874C14.7043 19.2269 14.595 19.5319 14.3656 19.7697L14.3617 19.7735C14.1324 19.9986 13.8424 20.1083 13.5074 20.1083C13.1814 20.1083 12.897 19.9808 12.6637 19.7389C12.4303 19.497 12.3106 19.2052 12.3106 18.874C12.3106 18.5162 12.4114 18.2099 12.6338 17.9792C12.8572 17.7476 13.1567 17.6406 13.5074 17.6406Z"
            fill="#1E3761"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1347 7.89167C14.7183 7.89172 15.2385 8.0109 15.6894 8.25534L15.8559 8.34962C16.2339 8.57997 16.5378 8.87605 16.7641 9.23764C17.0232 9.65167 17.1528 10.1115 17.1528 10.6115C17.1527 11.1615 17.0487 11.6358 16.8286 12.0239C16.6198 12.3917 16.3635 12.7172 16.0598 12.9994L16.057 13.0023C15.7676 13.2609 15.473 13.5192 15.1738 13.7778C14.9003 14.0124 14.6694 14.2814 14.481 14.584L14.4791 14.5859C14.3057 14.8556 14.2117 15.2082 14.2117 15.6558V16.7189H12.7021L12.6608 16.5765C12.6083 16.3917 12.5676 16.1918 12.5367 15.9781L12.5347 15.9684C12.5143 15.757 12.5039 15.5594 12.5039 15.3768C12.504 14.8283 12.6031 14.3554 12.8118 13.9683C13.0103 13.5897 13.2569 13.2625 13.5526 12.9888C13.834 12.7181 14.1161 12.4673 14.3983 12.2374C14.6654 12.0199 14.8871 11.7894 15.065 11.5467C15.2269 11.3157 15.3104 11.0425 15.3104 10.7193C15.3103 10.4135 15.1987 10.1483 14.965 9.91495L14.9631 9.91206C14.7383 9.67913 14.43 9.55522 14.0154 9.55513C13.6425 9.55513 13.3101 9.64859 13.0148 9.83414C12.7103 10.0255 12.4293 10.2912 12.173 10.6356L12.0489 10.803L11.8892 10.6702L10.7712 9.74274L10.8896 9.59169C11.3005 9.06977 11.761 8.65529 12.2721 8.35251C12.7959 8.04219 13.4202 7.89167 14.1347 7.89167ZM16.9498 10.4393L16.9382 10.3133C16.9373 10.3055 16.9363 10.2979 16.9353 10.2902C16.9416 10.3394 16.9465 10.3891 16.9498 10.4393ZM12.6694 9.83606C12.658 9.84498 12.6481 9.85579 12.6367 9.86492C12.687 9.82452 12.737 9.7849 12.7887 9.74851L12.6694 9.83606Z"
            fill="#1E3761"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 4C19.5226 4 24 8.47737 24 14C24 19.5226 19.5226 24 14 24C8.47737 24 4 19.5226 4 14C4 8.47737 8.47737 4 14 4ZM14 5.7741C9.45675 5.7741 5.7741 9.45675 5.7741 14C5.7741 18.5433 9.45675 22.2259 14 22.2259C18.5433 22.2259 22.2259 18.5433 22.2259 14C22.2259 9.45675 18.5433 5.7741 14 5.7741Z"
            fill="#1E3761"
          />
        </svg>
      );
      break;

    case 'vs':
      icon = (
        <svg width="53" height="20" viewBox="0 0 53 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M-1.84774e-06 14.232V10.296H7.704V14.232H-1.84774e-06ZM19.0721 0.335994H27.0881V4.272H26.1281L21.8321 19.008H14.0561L9.76012 4.272H8.80012V0.335994H18.0161V4.272H16.7681L18.4241 12.312H18.6641L20.3201 4.272H19.0721V0.335994ZM35.2993 19.344C33.7633 19.344 32.3073 19.216 30.9313 18.96C29.5713 18.688 28.5233 18.384 27.7873 18.048V13.296H33.0673C33.0673 13.792 33.1793 14.152 33.4033 14.376C33.6273 14.6 34.0353 14.712 34.6273 14.712C35.1233 14.712 35.4753 14.64 35.6833 14.496C35.9073 14.336 36.0193 14.104 36.0193 13.8C36.0193 13.544 35.9153 13.328 35.7073 13.152C35.4993 12.96 35.1393 12.768 34.6273 12.576L32.5633 11.856C30.7873 11.184 29.5073 10.392 28.7233 9.48C27.9553 8.568 27.5713 7.336 27.5713 5.784C27.5713 3.896 28.1873 2.46399 29.4193 1.488C30.6673 0.495995 32.7393 -5.72205e-06 35.6353 -5.72205e-06C37.0273 -5.72205e-06 38.3313 0.143994 39.5473 0.431994C40.7793 0.703995 41.7713 1.07199 42.5233 1.53599V5.832H37.7233C37.7233 5.03199 37.2273 4.63199 36.2353 4.63199C35.7553 4.63199 35.4113 4.69599 35.2033 4.824C35.0113 4.93599 34.9153 5.14399 34.9153 5.448C34.9153 5.72 35.0273 5.93599 35.2513 6.09599C35.4913 6.256 35.8753 6.424 36.4033 6.6L38.4913 7.32C40.1873 7.89599 41.4193 8.64799 42.1873 9.576C42.9713 10.488 43.3633 11.688 43.3633 13.176C43.3633 15.208 42.6753 16.744 41.2993 17.784C39.9393 18.824 37.9393 19.344 35.2993 19.344ZM44.3672 14.232V10.296H52.0712V14.232H44.3672Z"
            fill="#2B3853"
          />
        </svg>
      );
      break;

    case 'close':
      icon = (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_395_5227"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_395_5227)">
            <path
              d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
              fill="#1E3761"
            />
          </g>
        </svg>
      );
      break;

    case 'border':
      icon = (
        <svg width="354" height="10" viewBox="0 0 354 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="-4" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="21.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="46.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="72" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="97" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="122.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="147.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="173" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="198" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="223.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="249" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="274" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="299.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="325" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
          <rect x="348.5" y="0" width="11" height="10" rx="5" fill="#e9ebf0" />
        </svg>
      );
      break;

    case 'no-results':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
          <path
            d="M8.53074 13.512C6.8613 11.8634 5.2004 10.207 3.54797 8.54196C2.89303 7.88818 2.23251 7.23571 1.57895 6.58061C0.744065 5.74416 0.11869 5.05753 0.0391304 3.80844C-0.0293265 2.82219 0.318279 1.85235 0.997658 1.13483C1.66922 0.430453 2.59792 0.0283308 3.5711 0.0217601C4.21723 0.0204459 4.84944 0.209684 5.38882 0.565814C6.07234 1.00802 7.69178 2.71705 8.3458 3.37281L13.4967 8.53342C15.2447 6.84475 16.9438 5.04373 18.6828 3.3393C19.6461 2.50416 20.5462 1.22879 21.6371 0.563841C23.6934 -0.689845 25.5544 0.293124 26.6837 2.07838C27.1783 3.54627 27.0915 4.82296 25.9727 6.0024C24.8217 7.21534 23.6075 8.37112 22.4354 9.5637C21.1304 10.824 19.7845 12.3056 18.4676 13.5107C20.1415 15.1514 21.804 16.8033 23.4548 18.4663C24.3542 19.3658 25.7977 20.657 26.4691 21.6636C27.9413 23.8707 26.1617 26.9832 23.462 26.9997C22.8173 27.0089 22.1841 26.8295 21.6403 26.4832C20.9584 26.0509 19.3176 24.3346 18.6377 23.6473C17.0623 22.0552 15.4284 20.4599 13.8662 18.8579L13.5056 18.4847L8.4659 23.5376C7.50803 24.4962 6.32041 25.8189 5.2006 26.5837C4.41531 27.1199 2.96747 27.0673 2.08844 26.6994C-0.00344215 25.4128 -0.7294 23.236 0.865738 21.1984C2.23809 19.6385 4.09195 18.0727 5.49952 16.5004C6.03476 16.1791 7.89952 14.11 8.53074 13.512Z"
            fill="#E9EBF0"
          />
        </svg>
      );
      break;

    case 'results-star':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="402" height="285" viewBox="0 0 402 285" fill="none">
          <style>
            {`
          @keyframes kf_Star_1_transform_0 { 
            0% { transform: translateX(-97px) translateY(-156px) translate(298px, 298px) rotate(0rad) translate(-298px, -298px); } 
            100% { transform: translateX(-97px) translateY(-156px) translate(298px, 298px) rotate(-2.094rad) translate(-298px, -298px); } 
          } 
          #Star_1 { 
            transform-origin: 0 0; 
            animation: kf_Star_1_transform_0 3s linear infinite; 
          }
        `}
          </style>
          <g id="Rotation" clipPath="url(#clip0_646_1733)">
            <rect width="402" height="285" id="Rotation_bg_0" fill="#E9EBF0" />
            <rect
              id="Rectangle_67"
              transform="translate(16 -45)"
              width="371"
              height="374"
              fill="url(#paint0_radial_646_1733)"
            />
            <path
              id="Star_1"
              transform="translate(-97 -156)"
              d="M298 0L311.575 247.339L447 39.9244L335.086 260.914L556.076 149L348.661 284.425L596 298L348.661 311.575L556.076 447L335.086 335.086L447 556.076L311.575 348.661L298 596L284.425 348.661L149 556.076L260.914 335.086L39.9244 447L247.339 311.575L0 298L247.339 284.425L39.9244 149L260.914 260.914L149 39.9244L284.425 247.339L298 0Z"
              fill="#E9EBF0"
            />
          </g>
          <defs>
            <radialGradient
              id="paint0_radial_646_1733"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(185.5 187) rotate(90) scale(187 185.5)"
            >
              <stop offset="0.274038" stopColor="#F8F8F8" />
              <stop offset="0.836538" stopColor="#E9EBF0" />
            </radialGradient>
            <clipPath id="clip0_646_1733">
              <rect width="402" height="285" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    default:
      break;
  }

  return (
    <i className={classNames(css.icon, className)} {...iconProps}>
      {icon}
    </i>
  );
};

export default Icon;
